import { call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import Http from '../../../../../libs/Http';

export function* fetchClientDataAndTrades(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  const tradesResult = yield call(Http.get, '/admin/tradesFromUser', {
    query: {
      username: payload.username,
    }
  });

  const clientResult = yield call(Http.get, '/clients/client', {
    query: {
      username: payload.username,
    }
  });

  yield put({
    // $global: true,
    type: 'SET_CLIENT_DATA_AND_TRADES',
    payload: {
      trades: tradesResult.trades,
      client: clientResult.client,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}


export function* updateClientTrustStatus(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });
  const statusAction = payload.statusAction;

  yield call(Http.post, '/clients/' + statusAction, {
    body: {
      username: payload.username,
    }
  });

  const clientResult = yield call(Http.get, '/clients/client', {
    query: {
      username: payload.username,
    }
  });

  yield put({
    // $global: true,
    type: 'SET_CLIENT_DATA',
    payload: clientResult.client,
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}
export function* updateClientRedeemStatus(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });
  const { username, redeemStatus } = payload;

  yield call(Http.post, '/clients/clientRedeemStatus', {
    body: {
      username,
      redeemStatus,
    },
  });

  const clientResult = yield call(Http.get, '/clients/client', {
    query: {
      username,
    },
  });

  yield put({
    // $global: true,
    type: 'SET_CLIENT_DATA',
    payload: clientResult.client,
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest }) {
  yield [
    takeFirst('FETCH_CLIENT_DATA_AND_TRADES', fetchClientDataAndTrades),
    takeFirst('UPDATE_CLIENT_TRUST_STATUS', updateClientTrustStatus),
    takeFirst('UPDATE_CLIENT_REDEEM_STATUS', updateClientRedeemStatus),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientModal.sagas.js